(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/fetch-draw-data.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/fetch-draw-data.js');
"use strict";


const NUMBER_OF_PRIMARY_DRAWS_PER_WEEK = 1;
const NUMBER_OF_SECONDARY_DRAWS_PER_WEEK = 2;
const jupiter = svs.core.jupiter;
async function fetchDrawData(numberOfWeeks) {
  const [geo1, geo2] = await Promise.all([jupiter.callAsync({
    path: '/draw/1/lyckoplatsenprimary/draws',
    method: 'GET'
  }), jupiter.callAsync({
    path: '/draw/1/lyckoplatsensecondary/draws',
    method: 'GET'
  })]);
  const primaryDraw = geo1.response.draws.currentDraw;
  const secondaryDraw = geo2.response.draws[0];
  const [firstDraw] = [primaryDraw, secondaryDraw].sort((a, b) => new Date(a.regCloseTime) - new Date(b.regCloseTime));
  const primaryDrawNumber = primaryDraw.drawNumber + (NUMBER_OF_PRIMARY_DRAWS_PER_WEEK * numberOfWeeks - 1);
  const secondaryDrawNumber = secondaryDraw.drawNumber + (NUMBER_OF_SECONDARY_DRAWS_PER_WEEK * numberOfWeeks - 1);
  const [furuteGeo1, furuteGeo2] = await Promise.all([jupiter.callAsync({
    path: "/draw/1/lyckoplatsenprimary/draws/".concat(primaryDrawNumber),
    method: 'GET'
  }), jupiter.callAsync({
    path: "/draw/1/lyckoplatsensecondary/draws/".concat(secondaryDrawNumber),
    method: 'GET'
  })]);
  const [lastDraw] = [furuteGeo1.response.draw, furuteGeo2.response.draw].sort((a, b) => new Date(b.regCloseTime) - new Date(a.regCloseTime));
  return {
    primaryDraw,
    secondaryDraw,
    firstDraw,
    lastDraw
  };
}
async function getDrawData(_ref) {
  let {
    next,
    numberOfWeeks
  } = _ref;
  const {
    primaryDraw,
    secondaryDraw,
    firstDraw,
    lastDraw
  } = await fetchDrawData(numberOfWeeks);
  next({
    primaryDraw,
    secondaryDraw,
    firstDraw,
    lastDraw
  });
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  fetchDrawData,
  getDrawData
});

 })(window);